import React, { useState } from "react"
import axios from "axios"
import { useParams, Link } from "react-router-dom"
import "../styles/resetarSenha.css"

function ResetarSenha() {
  const { token } = useParams()
  const [novaSenha, setNovaSenha] = useState("")
  const [mensagem, setMensagem] = useState("")
  const [erro, setErro] = useState("")
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setMensagem("")
    setErro("")
    setLoading(true)

    try {
      await axios.post(
        "https://api.ticketdovaqueiro.com/api/auth/resetar-senha",
        { token, novaSenha }
      )

      setMensagem("✅ Senha redefinida com sucesso! Você já pode fazer login.")
      setNovaSenha("")
    } catch (err) {
      setErro("❌ Erro ao redefinir senha. O link pode ter expirado.")
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="reset-page">
      <div className="reset-overlay">
        <div className="reset-container">
          <div className="reset-header">
            <div className="reset-back-button">
              <Link to="/login">← Voltar para login</Link>
            </div>

            <h2 className="reset-title">Redefinir Senha</h2>
          </div>

          <div className="reset-content">
            <p className="reset-description">
              Digite sua nova senha abaixo para concluir a redefinição.
            </p>

            {erro && <div className="reset-message reset-error">{erro}</div>}
            {mensagem && (
              <div className="reset-message reset-success">{mensagem}</div>
            )}

            <form className="reset-form" onSubmit={handleSubmit}>
              <div className="reset-form-group">
                <label className="reset-label">Nova Senha</label>
                <div className="reset-input-wrapper">
                  <input
                    type="password"
                    className="reset-input"
                    placeholder="Digite sua nova senha"
                    value={novaSenha}
                    onChange={(e) => setNovaSenha(e.target.value)}
                    required
                    minLength={6}
                  />
                </div>
              </div>

              <button
                className="reset-button"
                type="submit"
                disabled={loading}
              >
                {loading ? "Salvando..." : "Salvar Nova Senha"}
              </button>
            </form>

            <div className="reset-footer">
              <p>
                Lembrou da senha?{" "}
                <Link to="/login" className="reset-login-link">
                  Fazer login
                </Link>
              </p>
            </div>
          </div>
        </div>

        <div className="reset-page-footer">
          © {new Date().getFullYear()} Ticket do Vaqueiro
        </div>
      </div>
    </div>
  )
}

export default ResetarSenha
